import { GlPopover, GlLink, GlAvatar, GlIcon, GlTruncate } from '../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { __, sprintf } from '~/locale';
import { getTimeago } from '~/lib/utils/datetime_utility';
import defaultAvatarUrl from 'images/no_avatar.png';
export default {
    name: 'CommitPopover',
    components: {
        GlPopover,
        GlLink,
        GlAvatar,
        GlIcon,
        GlTruncate
    },
    props: {
        popoverTargetId: {
            type: String,
            required: true
        },
        commit: {
            type: Object,
            required: true
        }
    },
    computed: {
        authorName () {
            return this.commit.author?.name || this.commit.authorName || '';
        },
        avatarUrl () {
            return this.commit.author?.avatarUrl || this.commit.authorGravatar || this.commit.avatarUrl || defaultAvatarUrl;
        },
        authoredDate () {
            return this.commit?.authoredDate;
        },
        commitUrl () {
            return this.commit.webPath || this.commit.commitUrl;
        },
        authoredText () {
            if (!this.authoredDate) return '';
            const timeago = getTimeago().format(new Date(this.authoredDate));
            return sprintf(__('Authored %{timeago}'), {
                timeago
            });
        }
    }
};
